import PageShell from "@/components/layout/PageShell";
import PageCTA from "@/components/sections/PageCTA";
import Pricing from "@/components/sections/Pricing";
import FAQ from "@/components/sections/FAQ";

export default function PricingPage() {
  return (
    <PageShell
      testId="pricing-page"
      eyebrow="Packages & pricing"
      title={<>Simple, honest pricing — <span className="text-apex-orange">no bloat.</span></>}
      subtitle="Three starting points from APEX Innovation Solutions. Every quote is finalized after a free strategy call so pricing fits your actual goals, timeline, and scope."
      breadcrumbs={[{ label: "Pricing" }]}
      seoTitle="Pricing & Packages | Web Design + SEO Cost — APEX Innovation Solutions"
      seoDescription="Transparent pricing from APEX Innovation Solutions. Launch, Growth, and Apex Pro packages — starting from $2,400. Currency toggle for USD and INR."
    >
      <section className="pb-8 md:pb-10 relative">
        <div className="container-apex">
          <p className="text-white/75 leading-relaxed max-w-4xl" data-align-preserve>
            Choose the package closest to your goals. Every APEX project is scoped in a written proposal after a discovery call — no surprise fees, no last-minute add-ons. Prices below are starting points and are billed by APEX Innovation Solutions (India) or APEX Innovation Solutions LLC (Utah, USA) depending on your location.
          </p>
        </div>
      </section>

      <Pricing />

      <section className="pb-16 md:pb-20 relative">
        <div className="container-apex">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {[
              { t: "What's included?", d: "Design, development, SEO foundation, analytics, and revisions as scoped in your proposal." },
              { t: "How long does it take?", d: "Launch: 2–3 weeks. Growth: 4–6 weeks. Apex Pro: custom timeline based on scope." },
              { t: "Do you offer retainers?", d: "Yes. Monthly retainers cover ongoing content, SEO, CRO, and reporting — priced by scope." },
            ].map((x) => (
              <div key={x.t} className="glass p-6">
                <div className="text-[11px] uppercase tracking-widest text-apex-cyan font-bold mb-2">Common Q</div>
                <div className="font-heading font-bold text-white text-base">{x.t}</div>
                <p className="mt-2 text-sm text-white/70 leading-relaxed" data-align-preserve>{x.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <FAQ />

      <PageCTA
        title="Not sure which package fits?"
        subtitle="Book a free 30-minute call — we'll recommend the right starting point and give you a clear next step."
        primary={{ label: "Book a Strategy Call", to: "/contact" }}
        secondary={{ label: "See Our Work", to: "/work" }}
      />
    </PageShell>
  );
}
